import ReactDOM from 'react-dom'
import { App } from './components/App'
import 'react-calendar/dist/Calendar.css'
import './css/index.scss'
import './css/buttons.scss'
import './css/fixit.scss'
import './css/settings.scss'
import './css/nav-header.scss'
import './css/homepage.scss'
import './css/title.css'
import './css/signin.scss'
import './css/modal.css'
import './css/options-modal.css'
import './css/error-modal.css'
import './css/file-upload-modal.css'
import './css/profile.scss'
import './css/questions.scss'
import './css/summary.scss'
import './css/faq.css'
import { LocalisationServiceProvider } from 'providers/LocalisationProvider'
import TelemetryServiceWrapper from 'services/TelemetryServiceWrapper'
import FirebaseTelemetryService from 'services/Firebase/FirebaseTelemetryService'
import FirebaseAuthenticationService from 'services/Firebase/FirebaseAuthenticationService'
import AuthenticationServiceWrapper from 'services/AuthenticationServiceWrapper'
import { initializeApp } from 'firebase/app'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'

const FunctionRegion = import.meta.env.VITE_CLOUD_FUNCTION_REGION;

const LOCAL_ENV = 'LOCAL'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
}

const app = initializeApp(firebaseConfig)
const auth = getAuth(app)
const functions = getFunctions(app, FunctionRegion)
const db = getFirestore(app)

if (import.meta.env.VITE_ENVIRONMENT === LOCAL_ENV) {
  console.log('Setting up emulators')
  connectAuthEmulator(auth, "http://localhost:9099")
  connectFunctionsEmulator(functions, "localhost", 5001)
  connectFirestoreEmulator(db, "localhost", 8080)
}

const userProperties = {
  environment: import.meta.env.VITE_ENVIRONMENT
}

const _telemetryService = new TelemetryServiceWrapper(
  new FirebaseTelemetryService(userProperties)
)
const _authenticationService = new AuthenticationServiceWrapper(
  new FirebaseAuthenticationService()
)

console.log(`This is a ${import.meta.env.VITE_ENVIRONMENT} build.`)

ReactDOM.render(
  <LocalisationServiceProvider>
    <App
      telemetryService={_telemetryService}
      authenticationService={_authenticationService}
      cloudFunctions={functions}
    />
  </LocalisationServiceProvider>,
  document.getElementById('root')
)
